import { useAnalysisStore } from '@modules/analysis/store/analysisStore';
import { INITIAL_ANALYSIS } from '@modules/analysis/store/constants';
import { CircularLoader } from '@modules/common/components/CircularLoader';
import {
  useSetAnalysisInQuantify,
  useUpdateQuantifyStoreFromURL,
} from '@modules/quantify/hooks';
import { QuantifyActionType } from '@modules/quantify/store/quantifyActionType';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { getQuantifyQueryRetentionKey } from '@modules/quantify/utils';
import { Box } from '@mui/material';
import { AnalysisViewFragment } from 'generated/graphql';
import { useEffect } from 'react';
import useParseSavedSlugInfo from 'v2/core/services/savedSlug/useParseSavedSlugInfo';
import { useGetUser } from 'v2/core/services/user';
import { QuantifyAnalysis } from '../QuantifyAnalysis/QuantifyAnalysis';

interface SavedQuantifyAnalysisProps {
  data?: AnalysisViewFragment;
}

export function SavedQuantifyAnalysis({ data }: SavedQuantifyAnalysisProps) {
  const {
    tenant: { slug: tenantSlug },
  } = useGetUser();

  const analysis = useAnalysisStore();
  const { isLoading } = useUpdateQuantifyStoreFromURL({});
  const { token } = useParseSavedSlugInfo();
  const dispatch = useQuantifyStore(({ dispatch }) => dispatch);

  useEffect(() => {
    if (!analysis.viewToken || analysis.viewToken !== token) {
      dispatch({
        type: QuantifyActionType.RESET_QUERY,
      });
      analysis.setAnalysis({
        ...analysis,
        ...INITIAL_ANALYSIS,
        isLoading: true,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [analysis.viewToken, token]);

  const isAnalysisReady =
    data &&
    data?.viewToken === token &&
    (!analysis.viewToken || analysis.viewToken !== token);

  useSetAnalysisInQuantify({
    analysis: isAnalysisReady ? data : undefined,
  });

  useEffect(() => {
    sessionStorage.removeItem(getQuantifyQueryRetentionKey(tenantSlug));
  }, [tenantSlug]);

  if (isLoading) {
    return (
      <Box height="100vh">
        <CircularLoader />
      </Box>
    );
  }

  return <QuantifyAnalysis />;
}
